export const WORK_IN_PROGRESS = '/wip';

export const LOGIN = '/login';
export const REGISTER = '/register';
export const LANDING = '/';
// export const HOME = '/home';
export const ACCOUNT = '/account';
// export const PASSWORD_FORGET = '/pw-forget';
export const USER_MANAGEMENT = '/userMgmt';

//  INFO
export const PRIVACY_POLICY = '/info/privacyPolicy';
export const TERMS_OF_SERVICE = '/info/tos';



// WEBPACK FOOTER //
// ./src/constants/routesConstants.js